import React, { FC } from 'react'

import { ArtistAvatar, ConditionRender } from 'components'
import { ProjectCreateContainer, StepperNavigation } from 'modules/ProjectCreate/components'

import { ProductTable } from 'modulesCommon/ProductTable/components'

import { IConfirmationFormProps } from './ConfirmationForm.props'
import './ConfirmationForm.scss'

const ConfirmationForm: FC<IConfirmationFormProps> = ({ onGoToNextStep, artist, project, products }) => (
  <div className="confirmation">
    <StepperNavigation onNext={onGoToNextStep} />
    <ProjectCreateContainer>
      <h3 className="confirmation__title">Project overview</h3>
      <div className="confirmation-artist">
        <ArtistAvatar
          className="confirmation-artist__avatar"
          facebookId={artist?.facebook_id || ''}
          spotifyId={artist?.spotify_id || ''}
          size="s"
          isImage
        />
        <div className="confirmation-artist__info">
          <div>
            <h6 className="confirmation-artist__title">Artist</h6>
            <p className="confirmation-artist__value">{artist.name}</p>
          </div>
          <div>
            <h6 className="confirmation-artist__title">Project</h6>
            <p className="confirmation-artist__value">{project.name}</p>
          </div>
          <div>
            <h6 className="confirmation-artist__title">OPUS-ID</h6>
            <p className="confirmation-artist__value">{artist.opus_id ? `GRP-${artist.opus_id}` : 'None'}</p>
          </div>
          <div>
            <h6 className="confirmation-artist__title">Unit</h6>
            <p className="confirmation-artist__value">{project.unitLabel}</p>
          </div>
          <div>
            <h6 className="confirmation-artist__title">GPS Artist Status</h6>
            <p className="confirmation-artist__value">{artist.gpsStatusLabel}</p>
          </div>
        </div>
      </div>
      <ConditionRender
        condition={!!products?.length}
        component={
          <section className="confirmation-products">
            <h2 className="confirmation-products__title">Products</h2>
            <ProductTable
              products={products}
              editingRowIdx={null}
              handleRowClose={() => {}}
              handleAddProduct={() => Promise.resolve()}
              handleRowEdit={() => {}}
              isEditable={false}
            />
          </section>
        }
      />
    </ProjectCreateContainer>
    <div className="confirmation-project">
      <div className="confirmation-project__left">
        <div className="confirmation-project__info" dangerouslySetInnerHTML={{ __html: project.team_info }} />
        <ConditionRender
          condition={!!project?.isaac_url?.length}
          component={
            <div className="confirmation-project__info">
              <h1>Local ISAAC</h1>
              <ul>
                {project?.isaac_url?.map((link) => (
                  <li key={link.title}>{link.title}</li>
                ))}
              </ul>
            </div>
          }
        />
      </div>
      <div className="confirmation-project__right">
        <div className="confirmation-project__info" dangerouslySetInnerHTML={{ __html: project.info }}></div>
      </div>
    </div>
  </div>
)

export default ConfirmationForm
